import { IPostsApiResponse } from "models/post";
import { fetchAtClientSide } from "utils/misc/fetchClient";
import { NextPageContextEnhanced } from "../../../types/page";
import { __fetchServerSide } from "../../../private/__fetch";

const RECOMMENDED_ADS_FIELDS = ["id", "title", "first_image_uri", "view_type", "cv_id", "natural_date", "local_phone", "masked_local_phone", "price","first_image_thumb","share_deeplink"];
const RECOMMENDED_ADS_EXPANDS_LIGHT = [
  "postUrl",
  "price_list",
  "city",
  "neighborhood",
  "similarStringCps",
  "bookmarkStatus",
  "contactAddon",
  "branding",
  "is_authorized_member",
];
const RECOMMENDED_ADS_EXPANDS = [
  "postUrl",
  "custom_param_string",
  "subcategory_name",
  "custom_param_array",
  "city_name",
  "neighborhood",
  "imagesCount",
  "totalComments",
  "bookmarkStatus",
  "searchMember",
  "authorisedSeller",
  "note",
  "price_list",
  "chat_enabled",
  "contactAddon",
  "branding",
  "is_authorized_member",
];

export const getRecommendedAdsClientSide = async (
  postId: number | string | string[],
  page: number,
  noOfResults: number,
  allExpands = false,
  includeSelf: string | number = 0
): Promise<IPostsApiResponse> => {
  const expands = allExpands ? RECOMMENDED_ADS_EXPANDS.join(",") : RECOMMENDED_ADS_EXPANDS_LIGHT.join(",");
  const fields = RECOMMENDED_ADS_FIELDS.join(",");

  const url = `posts/${postId}/search-post-recommended?per-page=${noOfResults}&page=${page}&fields=${fields}&expand=${expands}&includeSelf=${includeSelf}`;
  const data = await fetchAtClientSide<IPostsApiResponse>({ url });

  return "items" in data ? data : null;
};

export const getRecommendedAdsServerSide = async (
  context: NextPageContextEnhanced,
  postId: number | string | string[],
  page: number,
  noOfResults: number,
  includeSelf: string | number = 0,
  allExpands = true,
): Promise<IPostsApiResponse> => {
  const expands = allExpands? RECOMMENDED_ADS_EXPANDS.join(",") : RECOMMENDED_ADS_EXPANDS_LIGHT.join(",");
  const fields = RECOMMENDED_ADS_FIELDS.join(",");

  const url = `posts/${postId}/search-post-recommended?per-page=${noOfResults}&page=${page}&fields=${fields}&expand=${expands}&includeSelf=${includeSelf}`;
  const data = await __fetchServerSide(url, context, 1);
  return "items" in data ? data : null;
};